export const ACTION_TYPES = {
  GET_VIEW_CONFIG_RESPONSE: 'account/GET_VIEW_CONFIG_RESPONSE',
  GET_SUBSCRIPTION_BY_CLIENT: 'account/GET_SUBSCRIPTION_BY_CLIENT',
  GET_SUBSCRIPTION_BY_SUB_NUMBER: 'account/GET_SUBSCRIPTION_BY_SUB_NUMBER',
  VERIFY_SUBSCRIPTION: 'account/VERIFY_SUBSCRIPTION',
  VERIFY_OTP: 'account/VERIFY_OTP',
  EMPTY_FOUND_SUBSCRIPTION: 'account/EMPTY_FOUND_SUBSCRIPTION',
  VERIFY_OTP_CODE: 'account/VERIFY_OTP_CODE',
  VERIFY_SPECIFIC: 'accout/VERIFY_SPECIFIC',
  CLEAN_VIEW_CONF: 'accout/CLEAN_VIEW_CONF',
  CLEAN_NUMBER_VERIFIED: 'accout/CLEAN_NUMBER_VERIFIED',
  UPDATE_VIEW_OBJECT: 'account/UPDATE_VIEW_OBJECT',
  VERIF_PREVIOUS_MAIL: 'account/VERIF_PREVIOUS_MAIL',
  RESET_STATE: 'account/RESET_STATE',
};
